import { qaItems } from "../data/content"

export function GoAllInOneSection() {
  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/message.svg" alt="" />
          </span>
          What is it?
        </span>

        <h2 className="mk-title">
          All in one place? <span className="mk-title-accent">Absolutely.</span>
        </h2>
        <p className="mk-subtitle">
          We created it to give you more time, peace of mind, and clarity.
        </p>

        <dl className="mk-qa-grid">
          {qaItems.map((item) => (
            <div key={item.question}>
              <dt>{item.question}</dt>
              <dd>{item.answer}</dd>
            </div>
          ))}
        </dl>

        <p style={{ fontSize: 20, fontWeight: 600, marginTop: 32 }}>
          Will it solve all my problems? No — but it will help you solve every
          single one of them.
        </p>
      </div>
    </div>
  )
}
